import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TableCommission from "./components/table-commission/TableCommission";

export function CommissionReportsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableCommission />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
